import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/restarantManage",
  name: "restarantManageIndex",
  redirect: "/restarantManage/Index",
  component: RouteView,
  meta: {
    title: "实时用餐",
    showNavBar: false,
  },
  children: [
    {
      path: "/restarantManage/Index",
      name: "restarantManageIndex",
      component: () => import("@/views/restarantManage/Index.vue"),
      meta: {
        title: "实时用餐",
      },
    },
    {
      path: "/restarantManage/OpenTable",
      name: "restarantManageOpenTable",
      component: () => import("@/views/restarantManage/OpenTable.vue"),
      meta: {
        title: "开台",
      },
    },
    {
      path: "/restarantManage/OrderFood",
      name: "restarantManageOrderFood",
      component: () => import("@/views/restarantManage/OrderFood.vue"),
      meta: {
        title: "点菜",
      },
    },
    {
      path: "/restarantManage/Detail",
      name: "restarantManageDetail",
      component: () => import("@/views/restarantManage/Detail.vue"),
      meta: {
        title: "点菜详情",
      },
    },
    {
      path: "/restarantManage/Checkout",
      name: "restarantManageCheckout",
      component: () => import("@/views/restarantManage/Checkout.vue"),
      meta: {
        title: "结账",
      },
    },
    {
      path: "/restarantManage/OrderList",
      name: "restarantManageOrderList",
      component: () => import("@/views/restarantManage/OrderList.vue"),
      meta: {
        title: "订单列表",
        showNavBar: true,
      },
    },
    {
      path: "/restarantManage/OrderDetail",
      name: "restarantManageOrderDetail",
      component: () => import("@/views/restarantManage/OrderDetail.vue"),
      meta: {
        title: "订单详情",
      },
    },
    {
      path: "/restarantManage/AddOrder",
      name: "restarantManageAddOrder",
      component: () => import("@/views/restarantManage/AddOrder.vue"),
      meta: {
        title: "新增预订",
      },
    },
  ],
};
